/**
 * Утилиты для оптимизации изображений
 */

/**
 * Проверяет поддержку WebP формата браузером
 */
export function supportsWebP(): Promise<boolean> {
    return new Promise((resolve) => {
        const webP = new Image();
        webP.onload = webP.onerror = () => {
            resolve(webP.height === 2);
        };
        webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    });
}

/**
 * Генерирует оптимизированный URL изображения
 */
export function getOptimizedImageUrl(
    baseUrl: string,
    type: string,
    src: string,
    options: {
        width?: number;
        height?: number;
        quality?: number;
        format?: 'webp' | 'jpeg' | 'png';
    } = {}
): string {
    const { width, height, quality = 80, format } = options;
    
    let url = `${baseUrl}${type}/${src}`;
    
    // Добавляем параметры оптимизации
    const params = new URLSearchParams();
    
    if (width) params.append('w', width.toString());
    if (height) params.append('h', height.toString());
    if (quality !== 80) params.append('q', quality.toString());
    if (format) params.append('f', format);
    
    if (params.toString()) {
        url += `?${params.toString()}`;
    }
    
    return url;
}

/**
 * Получает размеры изображения для responsive loading
 */
export function getResponsiveSizes(containerWidth: number): string {
    if (containerWidth <= 480) {
        return '100vw';
    } else if (containerWidth <= 768) {
        return '50vw';
    } else if (containerWidth <= 1024) {
        return '33vw';
    } else {
        return '25vw';
    }
}

/**
 * Создает srcset для responsive изображений
 */
export function createSrcSet(
    baseUrl: string,
    type: string,
    src: string,
    sizes: number[] = [320, 640, 960, 1280]
): string {
    return sizes
        .map(size => `${getOptimizedImageUrl(baseUrl, type, src, { width: size })} ${size}w`)
        .join(', ');
}
